import { Helmet } from "react-helmet";
import Loader from "../../../../Components/Loader";
import TokenService from "../../../../Services/Token.service";
import { Fragment, useContext, useEffect, useState } from "react";
import Toaster from "../../../../Components/Toaster";
import { GlobalInfo } from "../../../../Contexts/GlobalContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import AdminListTable from "../AdminListTable";
import ToTheUser from "./ToTheUser";
import EmailFooter from "./EmailFooter";
import { FaArrowUp } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";

function EmailSMSManagement() {
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const previousUrl = TokenService.getPrevLink();
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const { appUserIsLogin, theme, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);
    const handleBackToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Smooth scrolling
        });
    };
    const location = useLocation();
    useEffect(() => { 
        if (location.state?.toastMessage) {
                setShowToast(true);
                setToastMessage(location.state.toastMessage);
                setToastVariant(location.state.toastVariant); 
                 // Clear location.state to prevent the toast from triggering on refresh
                 navigate(location.pathname, { replace: true }); 
        } 
    },[], [location.state, showToast,navigate]);
    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <Fragment>
            <Helmet>
                <title>DonorX | Email & SMS Management</title>
            </Helmet>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
                {/* <div className="container"> */}
                <div className="el-middle-wrapper">
                <div className={`${isMobile ?  "" : "el-bg-table"}`}>
                    <h2 className="el-title">Email & SMS Management</h2>
                    <Link className="back-link" to={`/admin/administrative-settings`}><i className='el-icon-back'></i> Administrator Settings</Link>
                    <div className={`${ isMobile ? "mt-3" :  "el-profile-board p-3 ely-sample-request-details shadow-none"} `}>
                        <div className="el-card-content">
                            {/* el-custom-accordion */}
                            <div className="d-sm-flex align-items-md-center">
                                <div className="el-property-details-card-content el-new-property-details-card" >

                                    <div className="accordion accordion-flush" id="accordionFlushExample">
                                        <Accordion alwaysOpen defaultActiveKey={[0, 1, 2, 3]} flush>

                                      
                                            <ToTheUser useType={"requestor"} eventKey={0} />
                                            <ToTheUser useType={"donor"} eventKey={1} />
                                            <ToTheUser useType={"admin"} eventKey={2} />
                                            <EmailFooter eventKey={3} />
                                       
                                            {/* <Accordion.Item eventKey="1">
                                                <Accordion.Header><b>To the Donors</b></Accordion.Header>
                                                <Accordion.Body>

                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header><b>To the Super Admins and Admins</b></Accordion.Header>
                                                <Accordion.Body>

                                                </Accordion.Body>
                                            </Accordion.Item>


                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header><b>Email Footer</b></Accordion.Header>
                                                <Accordion.Body>

                                                </Accordion.Body>
                                            </Accordion.Item> */}

                                        </Accordion>
                                
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row col-md-12 mt-3">
                                            <div className="col-4"></div>
                                            <div className="col-4" >
                                                <button
                                                    onClick={handleBackToTop}
                                                    className="el-main-button mx-auto d-block"
                                                >
                                                    <span>  <FaArrowUp  className=" mb-1"/> Back to Top</span>
                                                </button>
                                            </div>
                                            <div className="col-4"></div>
                                        </div>
                </div> </div>
                
            </div>
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </Fragment>
    );
}

export default EmailSMSManagement